class DPNetworkError extends Error {

  constructor(message, statusCode, body) {

    super(message);  //will be .message

    this.name = 'DPNetworkError';
    this.code = statusCode;
    this.body = body;
  }
}

Object.defineProperty(DPNetworkError, 'name', { value: '' });

export default DPNetworkError;
